import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { Switch, Tooltip, Typography } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function ManualCampaign() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [contactGroups, setContactGroups] = React.useState([]);

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title


    useEffect(() => {
        dispatch(setCurrentPage('Manual Campaign'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };


    //Create contact group
    //Заменить энд поинт на  ручную компанию - как будет готов!!!!
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/user`, {
                ...data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //Заменить на данные компании - как будет готов энд поинт!!!!
    const [campaignData, setCampaignData] = useState<any>(
        {
            'channel': null,
            'partner': null,
            'leadgroup': null,
            'isclosed': '',
            'datefrom': null,
            'dateto': null,
            'lastcalldate': null,
            'datetoprocessfrom': null,
            'datetoprocessto': null,
            'timezonefrom': '',
            'timezoneto': '',
            'callsallfrom': null,
            'callsallto': null,
            'callsnotconnectedfrom': null,
            'callsnotconnectedto': null,
            'callsconnectedfrom': null,
            'callsconnectedto': null,
            'callsuserinputfrom': null,
            'callsuserinputto': null,
            'conversationtemplate': null,
            'interval': null,
            'maxcontacts': null
        }
    )

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setSPartners(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setConversationtemplates(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    async function getContactGroups(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/contactgroup`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setContactGroups(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        getPartners()
        getConversationtemplates()
        getContactGroups()
        console.log(campaignData);

    }, [type])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ maxWidth: 1220, width: '90vw', display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <FormControl sx={{ flex: "1 0 10rem" }}>
                            <InputLabel size="small" id="simple-select-label">Channel for calls</InputLabel>
                            <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, channel: e.target.value !== "" ? e.target.value : null })} value={campaignData.channel || ''} variant="outlined" size="small" label='Channel for calls' >
                                <MenuItem value={''}>Not selected</MenuItem>
                                {
                                    //Добавить слектор по каналам - когда будет готов

                                    // partners.map((el: any) => {
                                    //     return (
                                    //         <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                    //     )
                                    // })
                                }
                            </Select>
                        </FormControl>

                        <FormControl sx={{ flex: "1 0 10rem" }}>
                            <InputLabel size="small" id="simple-select-label">Partner's contacts</InputLabel>
                            <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, partner: e.target.value !== "" ? e.target.value : null })} value={campaignData.partner || ''} variant="outlined" size="small" label='Partners contacts' >
                                <MenuItem value={''}>Not selected</MenuItem>
                                {
                                    partners.map((el: any) => {
                                        return (
                                            <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        <FormControl sx={{ flex: "1 0 10rem" }}>
                            <InputLabel size="small" id="simple-select-label">Contact Group</InputLabel>
                            <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, leadgroup: e.target.value !== '' ? e.target.value : null })} value={campaignData.leadgroup || ''} variant="outlined" size="small" label='Initial Contact Group' >
                                {
                                    contactGroups.map((el: any) => {
                                        return (
                                            <MenuItem key={el.id} value={el.id}>{el.partnerbankcode} - {el.leadgroupcode}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        <FormControl sx={{ flex: "1 0 10rem" }}>
                            <InputLabel size="small" id="simple-select-label">Contact's status</InputLabel>
                            <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, isclosed: e.target.value !== "" ? e.target.value : null })} value={campaignData.isclosed || ''} variant="outlined" size="small" label='Contacts status' >
                                <MenuItem value={''}>Any</MenuItem>
                                <MenuItem value={'0'}>Open</MenuItem>
                                <MenuItem value={'1'}>Closed</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <DatePicker label='Contact date from' sx={{ flex: "1 0 8rem" }} slotProps={{ textField: { size: 'small', error: false } }} value={dayjs(campaignData.datefrom)} onChange={(e) => setCampaignData({ ...campaignData, datefrom: e || '' })} format="YYYY-MM-DD" />
                        <DatePicker label='Contact date to' sx={{ flex: "1 0 8rem" }} slotProps={{ textField: { size: 'small', error: false } }} value={dayjs(campaignData.dateto)} onChange={(e) => setCampaignData({ ...campaignData, dateto: e || '' })} format="YYYY-MM-DD" />
                    </Box>
                    <DatePicker label='Date of the last call' sx={{ width: '100%' }} slotProps={{ textField: { size: 'small', error: false } }} value={dayjs(campaignData.lastcalldate)} onChange={(e) => setCampaignData({ ...campaignData, lastcalldate: e || '' })} format="YYYY-MM-DD HH:mm" />
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <DatePicker label='Date of the next call from' sx={{ flex: "1 0 8rem" }} slotProps={{ textField: { size: 'small', error: false } }} value={dayjs(campaignData.datetoprocessfrom)} onChange={(e) => setCampaignData({ ...campaignData, datetoprocessfrom: e || '' })} format="YYYY-MM-DD HH:mm" />
                        <DatePicker label='Date of the next call to' sx={{ flex: "1 0 8rem" }} slotProps={{ textField: { size: 'small', error: false } }} value={dayjs(campaignData.datetoprocessto)} onChange={(e) => setCampaignData({ ...campaignData, datetoprocessto: e || '' })} format="YYYY-MM-DD HH:mm" />
                    </Box>
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <FormControl sx={{ flex: "1 0 8rem" }}>
                            <InputLabel size="small" id="simple-select-label">Time zone from</InputLabel>
                            <Select sx={{ width: "100%" }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, timezonefrom: e.target.value !== '' ? e.target.value : null })} value={campaignData.timezonefrom || ''} variant="outlined" size="small" label='Time zone from' >
                                <MenuItem value={""}>Not specified</MenuItem>
                                <MenuItem value={"-12"}>-12</MenuItem>
                                <MenuItem value={"-11"}>-11</MenuItem>
                                <MenuItem value={"-10"}>-10</MenuItem>
                                <MenuItem value={"-9"}>-9</MenuItem>
                                <MenuItem value={"-8"}>-8</MenuItem>
                                <MenuItem value={"-7"}>-7</MenuItem>
                                <MenuItem value={"-6"}>-6</MenuItem>
                                <MenuItem value={"-5"}>-5</MenuItem>
                                <MenuItem value={"-4"}>-4</MenuItem>
                                <MenuItem value={"-3"}>-3</MenuItem>
                                <MenuItem value={"-2"}>-2</MenuItem>
                                <MenuItem value={"-1"}>-1</MenuItem>
                                <MenuItem value={"0"}>UTC</MenuItem>
                                <MenuItem value={"1"}>+1</MenuItem>
                                <MenuItem value={"2"}>+2</MenuItem>
                                <MenuItem value={"3"}>+3</MenuItem>
                                <MenuItem value={"4"}>+4</MenuItem>
                                <MenuItem value={"5"}>+5</MenuItem>
                                <MenuItem value={"6"}>+6</MenuItem>
                                <MenuItem value={"7"}>+7</MenuItem>
                                <MenuItem value={"8"}>+8</MenuItem>
                                <MenuItem value={"9"}>+9</MenuItem>
                                <MenuItem value={"10"}>+10</MenuItem>
                                <MenuItem value={"11"}>+11</MenuItem>
                                <MenuItem value={"12"}>+12</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl sx={{ flex: "1 0 8rem" }}>
                            <InputLabel size="small" id="simple-select-label">Time zone to</InputLabel>
                            <Select sx={{ width: "100%" }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, timezoneto: e.target.value !== '' ? e.target.value : null })} value={campaignData.timezoneto || ''} variant="outlined" size="small" label='Time zone to' >
                                <MenuItem value={""}>Not specified</MenuItem>
                                <MenuItem value={"-12"}>-12</MenuItem>
                                <MenuItem value={"-11"}>-11</MenuItem>
                                <MenuItem value={"-10"}>-10</MenuItem>
                                <MenuItem value={"-9"}>-9</MenuItem>
                                <MenuItem value={"-8"}>-8</MenuItem>
                                <MenuItem value={"-7"}>-7</MenuItem>
                                <MenuItem value={"-6"}>-6</MenuItem>
                                <MenuItem value={"-5"}>-5</MenuItem>
                                <MenuItem value={"-4"}>-4</MenuItem>
                                <MenuItem value={"-3"}>-3</MenuItem>
                                <MenuItem value={"-2"}>-2</MenuItem>
                                <MenuItem value={"-1"}>-1</MenuItem>
                                <MenuItem value={"0"}>UTC</MenuItem>
                                <MenuItem value={"1"}>+1</MenuItem>
                                <MenuItem value={"2"}>+2</MenuItem>
                                <MenuItem value={"3"}>+3</MenuItem>
                                <MenuItem value={"4"}>+4</MenuItem>
                                <MenuItem value={"5"}>+5</MenuItem>
                                <MenuItem value={"6"}>+6</MenuItem>
                                <MenuItem value={"7"}>+7</MenuItem>
                                <MenuItem value={"8"}>+8</MenuItem>
                                <MenuItem value={"9"}>+9</MenuItem>
                                <MenuItem value={"10"}>+10</MenuItem>
                                <MenuItem value={"11"}>+11</MenuItem>
                                <MenuItem value={"12"}>+12</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <TextField sx={{ flex: "1 0 8rem" }} onChange={(e) => setCampaignData({ ...campaignData, callsallfrom: e.target.value !== '' ? e.target.value : null })} value={campaignData.callsallfrom || ''} variant="outlined" size="small" label='Total number of calls by contact from' />
                        <TextField sx={{ flex: "1 0 8rem" }} onChange={(e) => setCampaignData({ ...campaignData, callsallto: e.target.value !== '' ? e.target.value : null })} value={campaignData.callsallto || ''} variant="outlined" size="small" label='Total number of calls by contact to' />
                    </Box>
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <TextField sx={{ flex: "1 0 8rem" }} onChange={(e) => setCampaignData({ ...campaignData, callsnotconnectedfrom: e.target.value !== '' ? e.target.value : null })} value={campaignData.callsnotconnectedfrom || ''} variant="outlined" size="small" label='Unconnected calls by contact from' />
                        <TextField sx={{ flex: "1 0 8rem" }} onChange={(e) => setCampaignData({ ...campaignData, callsnotconnectedto: e.target.value !== '' ? e.target.value : null })} value={campaignData.callsnotconnectedto || ''} variant="outlined" size="small" label='Unconnected calls by contact to' />
                    </Box>
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <TextField sx={{ flex: "1 0 8rem" }} onChange={(e) => setCampaignData({ ...campaignData, callsconnectedfrom: e.target.value !== '' ? e.target.value : null })} value={campaignData.callsconnectedfrom || ''} variant="outlined" size="small" label='Connected (without input from the client) from' />
                        <TextField sx={{ flex: "1 0 8rem" }} onChange={(e) => setCampaignData({ ...campaignData, callsconnectedto: e.target.value !== '' ? e.target.value : null })} value={campaignData.callsconnectedto || ''} variant="outlined" size="small" label='Connected (without input from the client) to' />
                    </Box>
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <TextField sx={{ flex: "1 0 8rem" }} onChange={(e) => setCampaignData({ ...campaignData, callsuserinputfrom: e.target.value !== '' ? e.target.value : null })} value={campaignData.callsuserinputfrom || ''} variant="outlined" size="small" label='Calls with input from the client from' />
                        <TextField sx={{ flex: "1 0 8rem" }} onChange={(e) => setCampaignData({ ...campaignData, callsuserinputto: e.target.value !== '' ? e.target.value : null })} value={campaignData.callsuserinputto || ''} variant="outlined" size="small" label='Calls with input from the client to' />
                    </Box>
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <FormControl sx={{ flex: "1 0 15rem" }}>
                            <InputLabel size="small" id="simple-select-label">Conversation template</InputLabel>
                            <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, conversationtemplate: e.target.value !== '' ? e.target.value : null })} value={campaignData.conversationtemplate || ''} variant="outlined" size="small" label='Conversation template' >
                                {
                                    conversationtemplates.map((el: any) => {
                                        //make conversationtemplate list item
                                        return (
                                            <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        <TextField sx={{ flex: "1 0 15rem" }} onChange={(e) => setCampaignData({ ...campaignData, interval: e.target.value !== '' ? e.target.value : null })} value={campaignData.interval || ''} variant="outlined" size="small" label='Number of seconds between calls' />
                        <TextField sx={{ flex: "1 0 15rem" }} onChange={(e) => setCampaignData({ ...campaignData, maxcontacts: e.target.value !== '' ? e.target.value : null })} value={campaignData.maxcontacts || ''} variant="outlined" size="small" label='Maximum number of contacts for calling' />
                    </Box>

                </Box>
                {<Button onClick={() => postData(campaignData)} variant="contained" sx={{ width: "100%" }}>Start</Button>}
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/campaigns' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        Saving error
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Successfully saved
                    </Alert>}
            </Snackbar>
        </Box >
    )
}